/*
 * $Id:: service.js 2021/03/02 11:11 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import { sendRequest } from '../../common/utils';
import { getLocale } from '../../providers';

export const deleteApplication = (params) => {
    const { appId, applicationType } = params;
    const lang = getLocale();
    return sendRequest({
        url: `/applications/${applicationType}/${appId}/${lang}`,
        method: 'DELETE',
    })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return { error: { description: error.message, code: error.code, details: error.details } };
        });
};

export const resumeApplication = (params) => {
    const { appId, applicationType, name } = params;
    const lang = getLocale();
    return sendRequest({
        url: `/applications/${applicationType}/resume/${appId}/${lang}?name=${name}`,
        method: 'GET',
    })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return { error: { description: error.message, code: error.code, details: error.details } };
        });
};
